import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonToneProps } from 'src/components/ui/Button/Button';
import ContainerOverlay from 'src/components/ui/ContainerOverlay/ContainerOverlay';
import { useOutsideClick, useEventListeners } from 'src/hooks/utils';
import ContainerHead from 'src/components/ui/ContainerOverlay/ContainerHead/ContainerHead';
import AiChatPanel from 'src/components/layouts/AiChat/AiChat';
import styles from './AiChatOverlay.module.scss';

export interface AiChatOverlayProps {
  onClose: () => void;
}

const AiChatOverlay: React.FC<AiChatOverlayProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);
  const mainRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (mainRef.current) {
      setIsExpanded(true);
    }
  }, [mainRef]);

  useOutsideClick(mainRef, (e: MouseEvent) => {
    const event = e as MouseEvent;
    if (mainRef.current && !mainRef.current.contains(event.target as Node)) {
      setIsExpanded(false);
      onClose();
    }
  });

  useEventListeners([{ event: 'keydown' }], (event: Event) => {
    const e = event as KeyboardEvent;
    if (e.key === 'Escape') {
      setIsExpanded(false);
      onClose();
    }
  });

  return (
    <ContainerOverlay isExpanded={isExpanded} ref={mainRef} className={styles.root}>
      <ContainerHead>
        <div className="flex justify-between items-center w-full">
          <Button onClick={onClose} icon="close" tone={ButtonToneProps.GHOST} />
          <h2 className="typo-text-16--bold">{t('tracking.chat_title')}</h2>
          <span />
        </div>
      </ContainerHead>
      <div className={styles.container}>
        <AiChatPanel compact />
      </div>
    </ContainerOverlay>
  );
};

export default AiChatOverlay;
